// extracted by mini-css-extract-plugin
export default {"container":"FAQs_container__zz627","accordionContainer":"FAQs_accordionContainer__7jxzn","title":"FAQs_title__Q6Eft","button":"FAQs_button__kvf8i"};